<ng-container *ngIf="ratingsRange.length > 0">
  <div
    role="img"
    attr.aria-label="{{ ratingsRange.length }} {{
      'products.morningstar-review' | translate
    }}"
  >
    <ng-container *ngIf="!hybrid">
      <eds-icon
        size="small"
        *ngFor="let star of ratingsRange"
        type="star-active"
        theme="ratings"
      ></eds-icon>
    </ng-container>
    <ng-container *ngIf="hybrid">
      <eds-icon
        size="small"
        *ngFor="let star of ratingsRange"
        type="star-inactive"
        theme="ratings"
      ></eds-icon>
      <p class="spacing--none">
        <eds-icon
          type="info"
          size="small"
          tooltipPositionDefault="bottom"
          edsTooltip
          [analyticsName]="'products.morningstar-review' | translate"
          tooltipType="large"
          tooltipBehavior="fixed"
          [tooltipContent]="'products.morningstar-tooltip' | translate"
        ></eds-icon>
      </p>
    </ng-container>
  </div>

  <p *ngIf="showNumberOfFunds" class="spacing--none small">
    {{ numberOfFunds }} {{ "products.funds-in-category" | translate }}
  </p>

  <p *ngIf="showStarLabels" class="spacing--none small">
    {{ starLabel }}
  </p>
</ng-container>
<ng-container *ngIf="ratingsRange.length === 0"> — </ng-container>
